export default function createDateFormatter(locale) {
  return (date, options) => Intl.DateTimeFormat(locale, options).format(date);
}
